import React from 'react'
import { styled } from 'styled-components'
import {
	useResolvers,
	getScreen,
	useMissionStateSelector,
} from '../../../context'

export default function ImageScreen(): React$Node {
	const screen = useMissionStateSelector(getScreen)
	const { imageSourceResolver } = useResolvers()
	if (screen?.type !== 'IMAGE') {
		return null
	}
	return (
		<ImageStyling alt="Player Image" src={imageSourceResolver(screen.url)} />
	)
}

const ImageStyling = styled.img`
	height: 100%;
	object-fit: contain;
`
